import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import useStore from '@/store/useStore';
import { trackEventWithObject } from '@/utils/gaDataPush';
import FontIcon from '../FontIcon';

const BagDropdown = dynamic(() => import('./BagDropdown'), { ssr: false });

export default function Bag() {
  const [open, setOpen] = useState(false);
  const cart = useStore(state => state.cart);

  return (
    <div
      className={classNames('dropdown', { open: open && !!cart?.items?.length })}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a
        href="/shop/cart/"
        className="navitem"
        aria-label="My Bag"
        onClick={() => {
          trackEventWithObject({
            event: 'header',
            general_event_category: 'My Bag',
            general_event_section: 'Main Icon',
            general_event_details: 'Undefined',
          });
        }}
      >
        <FontIcon name="bag" />
        <span className="count" id="king-mybag-count">
          {!!cart.totalItems && cart.totalItems}
        </span>
      </a>
      <BagDropdown cart={cart} />
    </div>
  );
}
